<template>
    <div>

        <div v-if="doorLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div v-if="!door && doorLoading === false">
            <div class="row pb-4">
                <div class="col-md-8">
                    <h2 class="page-header-title">Sorry...</h2>
                </div>
            </div>
            <div class="widget">
                <div class="widget-body">
                    <p>The door could not be found. Please check the URL and try again.</p>
                    <p> <router-link to="/">Return Home</router-link></p>
                </div>
            </div>
        </div>

        <div v-if="!doorLoading && door">

            <div class="row pb-4">
                <div class="col-md-10">
                    <h2 class="page-header-title">
                        <router-link to="/door-maintenance-reports">
                        Door Maintenance Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'door-maintenance-report-view', params: {action: 'view', id: report.site_door_maintenance_report_id} }">
                            {{ report.job_number }} | {{ report.prepared_for }}
                        </router-link>
                        &raquo;
                        {{ door.door_identifier }} | {{ door.door_location }}        
                    </h2>
                </div>
                <div class="col-md-2">
                    <router-link :to="{ name: 'door-maintenance-report-edit-item', params: {id: parseInt(door.site_door_maintenance_report_item_id)} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                        Edit Door Set
                    </router-link>
                </div>
            </div>

            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Door Set Details</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <td><strong>Door ID</strong></td>
                                <td>{{ door.door_identifier }}</td>
                            </tr>
                            <tr>
                                <td><strong>Door Location</strong></td>
                                <td>{{ door.door_location }}</td>
                            </tr>
                            <tr>
                                <td><strong>Client Declared Resistance Period</strong></td>
                                <td>{{ door.declared_fire_resistance_period }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong v-if="report.use_bm_trada_template">ARTs carried out (ART No. and Rev No.)</strong>
                                    <strong v-else>Description of work carried out</strong>
                                </td>
                                <td>{{ door.arts_carried_out }}</td>
                            </tr>
                            <tr v-if="report.use_bm_trada_template">
                                <td><strong>Maintenance Label Fitted</strong></td>
                                <td>{{ door.maintenance_label_fitted ? 'Yes' : 'No' }}</td>
                            </tr>
                            <tr v-if="report.use_bm_trada_template">
                                <td><strong>Maintenance Completed Date</strong></td>
                                <td>{{ door.maintenance_date | formatDate }}</td>
                            </tr>
                            <tr>
                                <td><strong>Maintained By</strong></td>
                                <td>{{ door.maintained_by }}</td>
                            </tr>
                            <tr v-if="report.use_bm_trada_template">
                                <td><strong>Next Maintenance Due Date</strong></td>
                                <td>{{ door.next_maintenance_due_date | formatDate }}</td>
                            </tr>
                            <tr>
                                <td><strong>Comments</strong></td>
                                <td>{{ door.comments }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget" v-if="door.door_maintenance_report_item_images.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Photos</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <item-image
                                v-for="doorImage in door.door_maintenance_report_item_images"
                                v-bind:key="doorImage.door_maintenance_report_item_image_id"
                                v-bind:image="doorImage"
                        ></item-image>
                    </div>
                </div>
            </div>

            <div class="widget" v-if="door.offline_images !== undefined && door.offline_images.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Local Photos</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                <p class="mb-0 pb-0">Photos in this section have not yet been synced with the server.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-sm-3 pb-3 entity-row-6" v-for="(offlineImage, index) in door.offline_images" style="margin-bottom: 10px;">
                            <img v-bind:src="offlineImage.data" class="img-fluid">
                            <div class="image-actions">
                                <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                            </div>
                            <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="widget has-shadow">
                        <div class="widget-body border-bottom">
                            <router-link :to="{ name: 'door-maintenance-report-add-item', params: {id: report.site_door_maintenance_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                                Add Another Door Set
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import ItemImage from '../components/ItemImage.vue';
  import ImageRotate from '@/components/mixins/ImageRotate.js'

  export default {
    components: {
      ItemImage
    },
    mixins: [ImageRotate],
    data() {
      return {
        door: null,
        doorLoading: true,
        report: null,
        modifyingPhoto: false
      }
    },
    methods: {
      getDoor() {
        var vm = this;
        this.getDb(function onConnected(db) {
          try {
            var itemId = parseInt(vm.$route.params.id);
            var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
            var storeRequest = objectStore.get(itemId);
            storeRequest.onsuccess = function(event) {
              if (storeRequest.result !== undefined) {
                vm.door = storeRequest.result;
                vm.getReport();
              } else {
                vm.doorLoading = false;
              }
            };
            storeRequest.onerror = function(e) {
              vm.doorLoading = false;
            }
          } catch (e) {
            console.log(e);
          }
        });
      },
      getReport() {
        var vm = this;
        this.getDb(function onConnected(db) {
          try {
            var objectStore = db.transaction('door_maintenance_reports').objectStore('door_maintenance_reports');
            var storeRequest = objectStore.get(vm.door.site_door_maintenance_report_id);
            storeRequest.onsuccess = function(event) {
              if (storeRequest.result !== undefined) {
                vm.report = storeRequest.result;
              } else {
                vm.door = null;
              }
              vm.doorLoading = false;
            };
            storeRequest.onerror = function(e) {
              vm.door = null;
              vm.doorLoading = false;
            }
          } catch (e) {
            console.log(e);
          }
        })
      },
      removePhoto(index) {
          this.modifyingPhoto = true;
          this.door.offline_images.splice(index, 1);
          var vm = this;
          this.getDb(function onConnectedGetDoorSets(db) {
              var putRequest = db.transaction('door_maintenance_report_items', 'readwrite')
                      .objectStore('door_maintenance_report_items').put(vm.door);
              putRequest.onsuccess = function(event) {
                  vm.modifyingPhoto = false;
              };
              putRequest.onerror = function(event) {
                  alert("Unable to remove photo");
                  window.location = '';
              };
          });
      },
      rotatePhoto(index, degrees) {
          this.modifyingPhoto = true;
          this.rotateImage(this.door.offline_images[index].data, degrees).then(newDataUri => {
              this.door.offline_images[index].data = newDataUri;

              var vm = this;
              this.getDb(function onConnectedGetDoorSets(db) {
                  var putRequest = db.transaction('door_maintenance_report_items', 'readwrite')
                      .objectStore('door_maintenance_report_items').put(vm.door);
                  putRequest.onsuccess = function(event) {
                      vm.modifyingPhoto = false;
                  };
                  putRequest.onerror = function(event) {
                      alert("Unable to rotate photo");
                      window.location = '';
                  };
              });
          }).catch(e => {
              console.log(e);
              alert('Error occurred while trying to rotate photo');
              this.modifyingPhoto = false;
          });
      }
    },
    mounted () {
        const modulesData = this.$session.get('enabled_modules');
        if(!modulesData || modulesData.indexOf('FDIR') === -1) {
            this.$router.push('/');
            return;
        }
        
        this.getDoor();
    }
  }
</script>